export enum LAND_REGISTER_ISSUE_STATE {
    등록완료 = 1,
    발급중 = 2,
    완료 = 200,
    취소 = 3,
    서버에러 = 400,
    정부에러 = 500,
}

//   LOCAL_INIT = 100,
